"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNTING_SPLIT_SCHEDULE_SYNC_IDEMPOTENCY_PREFIX = exports.ACCOUNTING_SYNC_OPERATION_CREATE_SPLIT_SCHEDULE_INVOICE = void 0;
exports.buildAccountingSplitScheduleSyncIdempotencyKey = buildAccountingSplitScheduleSyncIdempotencyKey;
exports.parseAccountingSplitScheduleSyncIdempotencyKey = parseAccountingSplitScheduleSyncIdempotencyKey;
exports.isCreateSplitScheduleInvoiceAccountingSyncOp = isCreateSplitScheduleInvoiceAccountingSyncOp;
/**
 * Create **one** ACCREC / QBO sales invoice for a Nucleus **split** schedule.
 * Line items post to {@link AccountingAccountMappingSlot.CONTRACT_LIABILITY} — milestone / deferred
 * income only (**no platform fee lines**; HAN-410 posts fee as a bank charge at pay-in).
 *
 * **Idempotency**: one logical create per split project — `project_split:{projectId}`.
 *
 * Tranche payments and revenue recognition use separate operations (payment allocation +
 * {@link ACCOUNTING_SYNC_OPERATION_RECOGNIZE_SPLIT_TRANCHE_REVENUE}).
 */
exports.ACCOUNTING_SYNC_OPERATION_CREATE_SPLIT_SCHEDULE_INVOICE = "CREATE_SPLIT_SCHEDULE_INVOICE";
exports.ACCOUNTING_SPLIT_SCHEDULE_SYNC_IDEMPOTENCY_PREFIX = "project_split:";
const PROJECT_SPLIT_KEY_UUID = /^project_split:([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;
function buildAccountingSplitScheduleSyncIdempotencyKey(projectId) {
    return `${exports.ACCOUNTING_SPLIT_SCHEDULE_SYNC_IDEMPOTENCY_PREFIX}${projectId}`;
}
function parseAccountingSplitScheduleSyncIdempotencyKey(idempotencyKey) {
    const match = idempotencyKey.match(PROJECT_SPLIT_KEY_UUID);
    if (!match) {
        return null;
    }
    return { projectId: match[1] };
}
function isCreateSplitScheduleInvoiceAccountingSyncOp(operation) {
    return operation === exports.ACCOUNTING_SYNC_OPERATION_CREATE_SPLIT_SCHEDULE_INVOICE;
}
